export function isSameDay(date, otherDate) {
    return 0 === compareDate(date, otherDate);
}
export function isSameTimestamp(date, otherDate) {
    return 0 === compareTimestamp(date, otherDate);
}
export function isBeforeDate(date, otherDate) {
    return -1 === compareDate(date, otherDate);
}
export function compareDate(date, otherDate) {
    const compareYear = compare(date.getFullYear(), otherDate.getFullYear());
    if (0 !== compareYear) {
        return compareYear;
    }
    const compareMonth = compare(date.getMonth(), otherDate.getMonth());
    if (0 !== compareMonth) {
        return compareMonth;
    }
    return compare(date.getDate(), otherDate.getDate());
}
export function compareTimestamp(date, otherDate) {
    const compareDateResult = compareDate(date, otherDate);
    if (0 !== compareDateResult) {
        return compareDateResult;
    }
    const compareHour = compare(date.getHours(), otherDate.getHours());
    if (0 !== compareHour) {
        return compareHour;
    }
    const compareMinute = compare(date.getMinutes(), otherDate.getMinutes());
    if (0 !== compareMinute) {
        return compareMinute;
    }
    return compare(date.getSeconds(), otherDate.getSeconds());
}
function compare(value, otherValue) {
    if (value === otherValue) {
        return 0;
    }
    return (value < otherValue) ? -1 : 1;
}
